import { render, staticRenderFns } from "./SocialLearningLesson.vue?vue&type=template&id=15976760&scoped=true&"
import script from "./SocialLearningLesson.vue?vue&type=script&lang=js&"
export * from "./SocialLearningLesson.vue?vue&type=script&lang=js&"
import style0 from "./SocialLearningLesson.vue?vue&type=style&index=0&id=15976760&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15976760",
  null
  
)

export default component.exports